export default function (selector) {
    const thisSelector = document.querySelector(selector);
    if (thisSelector && thisSelector.length > 0) {
        setTimeout(() => {
            thisSelector.scrollIntoView({ behavior: 'smooth' });
        }, 500);
    }
}
